import { render, staticRenderFns } from "./pay-success-view.vue?vue&type=template&id=455aeee4&scoped=true"
import script from "./pay-success-view.vue?vue&type=script&lang=js"
export * from "./pay-success-view.vue?vue&type=script&lang=js"
import style0 from "./pay-success-view.vue?vue&type=style&index=0&id=455aeee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455aeee4",
  null
  
)

export default component.exports